<!-- @veltra/icons generated sha256:0f62047643db574f gen:8 source:src/svg/normal/check-rectangle-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'CheckRectangleFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2 13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm5-3.643 3.426-3.426a.497.497 0 0 1 .705.007l.008.008a.49.49 0 0 1-.011.697l-3.774 3.774a.497.497 0 0 1-.705.004L4.864 8.636a.5.5 0 0 1 .708-.707z"
    />
  </svg>
</template>
